import React from 'react';
import { Divider } from '@amzn/storm-ui';
import { SIDEBAR_TYPE, ToolbarItem } from '@amzn/aac-chrome-internal-api';
import { ToolbarItemProps } from '../../store/slice';
import {
  MobileSideNavItemText,
  NonExpandableItemLink,
  StyledSvgIcon,
} from './styles';
import ExpandableMenuItem from './ExpandableMenuItem';
import { renderFlag } from 'src/commons/components/LaunchFlag/LaunchFlag.utils';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const MobileSideNavItem: React.VFC<ToolbarItem> = (
  sideNavItem: ToolbarItem,
) => {
  if (sideNavItem.sidebarType == SIDEBAR_TYPE.DIVIDER) {
    return <Divider />;
  }
  if (!sideNavItem.sidebarGroups) {
    return null;
  }
  const item = sideNavItem as ToolbarItemProps;

  if (
    item.sidebarGroups.length == 1 &&
    item.sidebarGroups[0].links.length == 1
  ) {
    return (
      <NonExpandableItemLink
        href={item.sidebarGroups[0].links[0].link.url}
        isSelected={item.sidebarGroups[0].links[0].isSelected}
        {...getTaktAttributes(
          item.sidebarGroups[0].links[0].id,
          chromeComponents.NAV,
          { url: item.sidebarGroups[0].links[0]?.link.url },
        )}
        data-ccx-e2e-id={item.sidebarGroups[0].links[0].id}
      >
        <StyledSvgIcon iconPath={item.iconPath} ariaLabel={item.toolTip} />
        <MobileSideNavItemText>
          {item.sidebarGroups[0].links[0].link.label}
          {renderFlag(item.sidebarGroups[0].links[0], {
            isMobile: true,
            isInverted: true,
          })}
        </MobileSideNavItemText>
      </NonExpandableItemLink>
    );
  } else {
    return <ExpandableMenuItem {...item} />;
  }
};

export default MobileSideNavItem;
